/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Callback, IErrorObject} from "../../../../types/platform/universe";

import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {retry} from "rxjs/operators";

import {PublicKeyService} from "../../platform/base/services/publickey.service";
import {Errors} from "../base/library/errors";
import {AuthService} from "../../platform/auth/auth.service";
import {SessionService} from "../../platform/base/services/session.service";

@Injectable({
	providedIn: "root",
})

/**
 * AUTHサービス
 *
 *
 */
export class AigiaAuth2Service extends AuthService {

	/**
	 * @constructor
	 * @param http
	 * @param PublicKey
	 * @param session
	 */
	constructor(
		protected http: HttpClient,
		protected PublicKey: PublicKeyService,
		protected session: SessionService
	) {
		super(http, PublicKey, session);
	}

	/**
	 * ユーザ登録
	 * メール存在確認あり
	 * @param auth
	 * @param username ユーザ名(メールアドレス)
	 * @param password パスワード
	 * @param category カテゴリー
	 * @param type タイプ
	 * @param metadata メタデータ
	 * @param callback コールバック
	 * locale
	 */
	public regist(auth: number, username: string, password: string, category: string, type: string, metadata: any, callback: Callback<any>): void {
		const lang = localStorage.getItem("language");
		this.PublicKey.fixed((error: IErrorObject, key: string): void => {
			if (!error) {
				this.value_encrypt(key, {auth, username, password, category, type, metadata, lang}, (error: IErrorObject, value: any): void => {
					if (!error) {
						this.http.post(this.endPoint + "/auth/guests2/register", {content: value}, this.httpOptions).pipe(retry(3)).subscribe(
							{
								next: (account: any): void => {
									if (account) {
										if (account.code === 0) {
											callback(null, account.value);
										} else {
											callback(Errors.serverError(account, "A00154"), null);
										}
									} else {
										callback(Errors.networkError("A00155"), null);
									}
								},
								error: (error: HttpErrorResponse): void => {
									callback(Errors.socketError(error, "A00156"), null);
								},
								complete: () => {
								}
							}
						);
					} else {
						callback(Errors.generalError(error.code, error.message, "A02516"), null);
					}
				});
			} else {
				callback(Errors.generalError(error.code, error.message, "A02616"), null);
			}
		});
	}

		/**
	 * 直接ユーザ登録
	 * メール存在確認なし
	 *
	 * @param auth
	 * @param username ユーザ名
	 * @param password パスワード
	 * @param metadata メタデータ
	 * @param category カテゴリー
	 * @param type タイプ
	*  @param origin_username
	 * @param callback コールバック
	 */
	public regist_immediate_with_relation(auth: number, username: string, password: string, category: string, type: string, metadata: any,origin_username:string, callback: Callback<any>): void {
		this.PublicKey.fixed((error: IErrorObject, key: string): void => {
			if (!error) {
				this.value_encrypt(key, {auth, username, password, category, type, metadata, origin_username}, (error: IErrorObject, value: any): void => {
					if (!error) {
						this.http.post(this.endPoint + "/auth/immediate/guests2/register", {content: value}, this.httpOptions).pipe(retry(3)).subscribe(
							{
								next: (result: any): void => {
									if (this.isNumber(result.code)) {
										if (result.code === 0) {
											callback(null, result.value);
										} else {
											callback(Errors.generalError(result.code, result.message, "A00155"), null);
										}
									} else {
										callback(Errors.httpError(500, "A00158"), null);
									}
								},
								error: (error: HttpErrorResponse): void => {
									callback(Errors.socketError(error, "A00159"), null);
								},
								complete: () => {
								}
							}
						);
					} else {
						callback(Errors.generalError(error.code, error.message, "A01116"), null);
					}
				});
			} else {
				callback(Errors.generalError(error.code, error.message, "A01216"), null);
			}
		});
	}

	/**
	 * ログアウト
	 *
	 * @param callback コールバック
	 */
	public logout(callback: Callback<any>): void {
		this.http.get(this.endPoint + "/auth/guests2/logout", this.httpOptions).pipe(retry(3)).subscribe(
			{
				next: (account: any): void => {
					if (account) {
						if (account.code === 0) {
							callback(null, account.value);
						} else {
							callback(null, null);
						}
					} else {
						callback(Errors.networkError("A00178"), null);
					}
				},
				error: (error: HttpErrorResponse): void => {
					callback(Errors.socketError(error, "A00179"), null);
				},
				complete: () => {
				}
			}
		);
	}

	public get_login_token(callback: Callback<any>): void {
		this.session.get((error, session: any) => {
			const value: any = session.data.token;
			this.http.get(this.endPoint + "/auth/token/qr/" + encodeURIComponent(value), this.httpOptions).pipe(retry(3)).subscribe(
				{
					next: (result: any): void => {
						if (result) {
							callback(null, result);
						} else {
							callback(Errors.networkError("A00109"), null);
						}
					},
					error: (error: HttpErrorResponse): void => {
						callback(Errors.socketError(error, "A00110"), null);
					},
					complete: () => {
					}
				}
			);
		})
	}

}
